import script from "./ReservationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationForm.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationForm.vue?vue&type=style&index=0&id=2d31d0e2&lang=scss"

const __exports__ = script;

export default __exports__